import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=08c03004&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c03004')) {
      api.createRecord('08c03004', component.options)
    } else {
      api.reload('08c03004', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=08c03004&", function () {
      api.rerender('08c03004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/imageCarousel.vue"
export default component.exports